import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { testimonials } from '../../data/testimonials';
import { container, focusRing } from '../../utils/styles';
import { SectionHeading } from './SectionHeading';
import { TestimonialCard } from './TestimonialCard';
interface TestimonialsDarkProps {
  showAllLink?: boolean;
}
export function TestimonialsDark({
  showAllLink = true
}: TestimonialsDarkProps) {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy py-20 sm:py-24" aria-labelledby="reviews-heading" data-id="element-450" data-mp="2vzktm7hyu3ia">
      <div className={container} data-id="element-451" data-mp="39qpwrjkjldxd">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-452" data-mp="39t2ebvme1m9w">
          <SectionHeading id="reviews-heading" tone="light" title={t({
          en: 'Real Stories — Families Who Trust Us',
          es: 'Historias Reales — Familias Que Confían en Nosotros'
        })} intro={t({
          en: "Genuine words from the families we've had the honor of caring for.",
          es: 'Palabras genuinas de las familias que hemos tenido el honor de cuidar.'
        })} data-id="element-453" data-mp="34uh9tk03sgfn" />
          <div className="flex shrink-0 flex-col gap-2 md:items-end" data-id="element-454" data-mp="25bt4hnfajo1q">
            <p className="font-display text-lg font-bold text-white" data-id="element-455" data-mp="2ab5sibhwf15w">
              5.0 <span className="text-gold" data-id="element-456" data-mp="2a92qsu7dvjlc">★★★★★</span>
            </p>
            {showAllLink && <Link to="/testimonials" className={`inline-flex items-center gap-2 rounded font-semibold text-gold hover:underline ${focusRing}`} data-id="element-457" data-mp="2f85xej30hxvf">
                {t({
              en: 'Read all reviews',
              es: 'Leer todas las reseñas'
            })}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-458" data-mp="2t1f4ue7eg9bb" />
              </Link>}
          </div>
        </div>
        <ul className="mt-12 grid gap-6 lg:grid-cols-3" data-id="element-459" data-mp="2y1t16yzn1uti">
          {testimonials.map(item => <li key={item.id} data-id="element-460" data-mp="330w7emrcu732">
              <TestimonialCard testimonial={item} data-id="element-461" data-mp="32xqip8mn177v" />
            </li>)}
        </ul>
      </div>
    </section>;
}